import type { FetchArgs } from "@reduxjs/toolkit/query/react";

export type FormDataEntry = [string, FormDataEntryValue];

/** Guarda cópia das entradas para reconstruir FormData após retry (stream é consumido no 1º envio). */
export function snapshotFormData(formData: FormData): FormDataEntry[] {
  return Array.from(formData.entries());
}

export function restoreFormData(entries: FormDataEntry[]): FormData {
  const formData = new FormData();
  for (const [key, value] of entries) {
    formData.append(key, value);
  }
  return formData;
}

export function withRestoredFormDataBody(args: string | FetchArgs, entries: FormDataEntry[]): FetchArgs {
  if (typeof args === "string") {
    return { url: args, body: restoreFormData(entries) };
  }
  return { ...args, body: restoreFormData(entries) };
}
